import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { apiSlice } from '../api/apiSlice';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export const reducers = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['profile'],
};

const persistedReducer = persistReducer(persistConfig, reducers);


export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }).concat(apiSlice.middleware)
});



